export const MESSAGE_REJECTED = 'MESSAGE_REJECTED';